const appModel = {
  category: {},
  link: {
    title: "Category",
    linkTo: "/"
  }
};

export default appModel;
